<template>

  <v-card class="mt-2 ml-2 mr-2 pa-4">
    <FVisitorTable/>
  </v-card>

</template>

<script>
import FVisitorTable from "../../components/setup/visitor/FVisitorTable.vue";

export default {
  components: { FVisitorTable },
  data() {
    return {
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>